import { render, staticRenderFns } from "./AddJurnal.vue?vue&type=template&id=d7ecc0e6&scoped=true"
import script from "./AddJurnal.vue?vue&type=script&lang=js"
export * from "./AddJurnal.vue?vue&type=script&lang=js"
import style0 from "./AddJurnal.vue?vue&type=style&index=0&id=d7ecc0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ecc0e6",
  null
  
)

export default component.exports